<script setup lang="ts">
import { computed, onMounted, toValue } from 'vue'
import { onBeforeRouteUpdate, useRoute } from 'vue-router'

const route = useRoute()
const legacyUrl = computed<string>(() => {
  let target = route.meta.target ?? ''

  const params = Object.entries(route.params)
  for (const [parameter, value] of params) {
    target = target.replace(`{${parameter}}`, String(value))
  }

  return target
})

function redirectToLegacyPage() {
  const target = toValue(legacyUrl)
  const currentPage = document.location.pathname + document.location.search.toString()
  if (currentPage !== target) {
    document.location.href = target
  }
}

onBeforeRouteUpdate(() => {
  redirectToLegacyPage()
})

onMounted(() => {
  redirectToLegacyPage()
})
</script>
<template>
  <div><!-- Trick ESLint --></div>
</template>
